import React from 'react';
import styles from './Sidebar.module.scss';
import { NavLink } from 'react-router-dom';
import Title from '../../shared/Title/Title';
import { getTranslation } from '../../../utils/translation';
// IMAGES
import Icon from './Icon/Icon';
import { useLocation } from 'react-router-dom';

const menus = [
    {
        name: getTranslation('othersSidebarTerminals'),
        url: '/app/point/terminals',
        iconRef: 'terminals',
        disabled: false,
    },
    {
        name: getTranslation('othersSidebarTickets'),
        url: '/app/point/tickets',
        iconRef: 'tickets',
        disabled: false,
    },
    {
        name: getTranslation('othersSidebarSportsbookPrint'),
        url: '/app/point/sportsbook',
        iconRef: 'sportsBook',
        disabled: false,
    },
    {
        name: getTranslation('othersSidebarReports'),
        url: '/app/point/reports',
        iconRef: 'reports',
        disabled: false,
    },
    {
        name: getTranslation('othersSidebarBalanceReport'),
        url: '/app/point/balance',
        iconRef: 'balance',
        disabled: false,
    },
    {
        name: getTranslation('othersSidebarCreditLimitIncreaseReport'),
        url: '/app/point/credit',
        iconRef: 'credit',
        disabled: false,
    },
    {
        name: getTranslation('othersSidebarConsumptions'),
        url: '/app/point/consumptions',
        iconRef: 'consumptions',
        disabled: true,
    },
];

export default function Sidebar() {
    const location = useLocation();
    return (
        <>
            <Title title={getTranslation('title.point')} />
            <nav className={styles.sidebar}>
                <ul>
                    {menus.map(menu => {
                        const isActive = location.pathname.startsWith(menu.url);

                        return (
                            <li key={menu.url} className={styles.navItem}>
                                {menu.disabled && (
                                    <div className={styles.comingSoon}>
                                        {getTranslation('comingSoon')}
                                    </div>
                                )}
                                <NavLink
                                    to={menu.url}
                                    className={styles.navLink}
                                    activeClassName={styles.active}
                                >
                                    <div className={styles.menuIcon}>
                                        <Icon iconRef={menu.iconRef} isActive={isActive} />
                                    </div>
                                    <span>{menu.name}</span>
                                </NavLink>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </>
    );
}
